import React from "react";
import {NavLink, useLocation} from "react-router-dom";
import Tooltip from "components/tooltips/Tooltips";
import UseContext from "hooks/useContext";
import { ORANGE_COLORS } from "utils/colors";

const SidebarUnitDesktop = ({routeSidebar, routeName, icon: IconComponent, text, exactMatch = false, children, isSubItem = false}) => {
    const {sidebarExpanded} = UseContext()
    const location = useLocation()
    const pathname = location.pathname
    
    // Détermine si l'item est actif (exact match ou includes selon le prop)
    // Pour les routes de fichiers, on vérifie si on est sur n'importe quelle page de fichiers
    // Pour les routes de timeSheet, on vérifie si on est sur n'importe quelle page de timeSheet
    // Pour les routes de missions, on vérifie si on est sur n'importe quelle page de missions
    const isActive = exactMatch 
        ? pathname === routeSidebar 
        : routeSidebar === '/contract/toBeSigned'
            ? pathname.includes('/contract')
            : routeSidebar === '/invoice/toBeSet'
                ? pathname.includes('/invoice')
                : routeSidebar === '/timeSheet/toBeChecked'
                    ? pathname.includes('/timeSheet')
                    : routeSidebar === '/profil/myAccountCompany'
                        ? pathname.includes('/profil')
                        : routeSidebar === '/missions/end' || routeSidebar === '/missions/inProgress'
                            ? pathname.includes('/missions') || pathname.includes('/mission/')
                            : pathname.includes(routeSidebar) || pathname === routeSidebar

    return (
        <>
            <li>
                <Tooltip
                    text={routeName}
                    disabled={sidebarExpanded}
                    placement="right"
                >
                    <NavLink
                        end={exactMatch}
                        to={routeSidebar}
                        className={({isActive: navIsActive}) => {
                            // Pour les routes non-exactes, vérifie aussi avec pathname
                            const active = exactMatch ? navIsActive : (navIsActive || isActive)
                            const baseClasses = `flex items-center justify-center h-[44px] rounded-lg border py-3 transition duration-150 ${!sidebarExpanded ? 'px-0' : 'px-2'}`
                            if (isSubItem && active) {
                                return `${baseClasses} hover:bg-gray-100 border-white text-gray-700 bg-gray-100`
                            }
                            return `${baseClasses} ${
                                active 
                                    ? 'border-yellow-100 text-yellow-600 bg-yellow-50 hover:border-yellow-200' 
                                    : 'border-white text-gray-700 bg-transparent hover:bg-gray-100 active:border-gray-200'
                            }`
                        }}
                        style={({isActive: navIsActive}) => {
                            const active = exactMatch ? navIsActive : (navIsActive || isActive)
                            if (isSubItem && active) {
                                return { backgroundColor: '#F3F4F6' }
                            }
                            return {}
                        }}
                    >
                        {sidebarExpanded ? (
                        <div id={routeName} className="flex items-center w-full">
                            {IconComponent && (
                                <span className='shrink-0'>
                                        <IconComponent wh={20} color={isActive ? ORANGE_COLORS[600] : '#374151'}/>
                                </span>
                            )}
                            {text && (
                                    <span className={`ft-sm font-normal ${IconComponent ? 'ml-4' : ''}`}>
                                    {text}
                                </span>
                            )}
                            {!IconComponent && !text && children}
                            {children && (IconComponent || text) && (
                                <div className="ml-auto">
                                    {children}
                                </div>
                            )}
                        </div>
                        ) : (
                            <div id={routeName} className="flex items-center justify-center">
                                {IconComponent && (
                                    <IconComponent wh={24} color={isActive ? ORANGE_COLORS[600] : '#374151'}/>
                                )}
                                {!IconComponent && children}
                            </div>
                        )}
                    </NavLink>
                </Tooltip>
            </li>
        </>
    );
};

export default SidebarUnitDesktop;
